var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEF3F2",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 19.6667C25.6267 19.6667 19.6667 25.6267 19.6667 33C19.6667 40.3733 25.6267 46.3333 33 46.3333C40.3733 46.3333 46.3333 40.3733 46.3333 33C46.3333 25.6267 40.3733 19.6667 33 19.6667ZM38.7333 38.7333C38.2133 39.2533 37.3733 39.2533 36.8533 38.7333L33 34.88L29.1467 38.7333C28.6267 39.2533 27.7867 39.2533 27.2667 38.7333C26.7467 38.2133 26.7467 37.3733 27.2667 36.8533L31.12 33L27.2667 29.1467C26.7467 28.6267 26.7467 27.7867 27.2667 27.2667C27.7867 26.7467 28.6267 26.7467 29.1467 27.2667L33 31.12L36.8533 27.2667C37.3733 26.7467 38.2133 26.7467 38.7333 27.2667C39.2533 27.7867 39.2533 28.6267 38.7333 29.1467L34.88 33L38.7333 36.8533C39.24 37.36 39.24 38.2133 38.7333 38.7333Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.0752cac9866f965ca00c6cb44a1e5669.svg";
export { ForwardRef as ReactComponent };